var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "outbound-history-page" },
    [
      _vm._l(_vm.resultList, function(item) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "order-item",
            on: {
              click: function($event) {
                return _vm.onclickSelectItem(item)
              }
            }
          },
          [
            _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "name" }, [
                _vm._v(
                  " " +
                    _vm._s(item.factoryName) +
                    _vm._s(item.deviceCountList[0].deviceTypeName) +
                    "x" +
                    _vm._s(item.outboundCount) +
                    " "
                )
              ]),
              _c("div", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm._f("formateTime")(item.time)))
              ])
            ]),
            _c(
              "div",
              { staticClass: "state" },
              [
                _c(
                  "div",
                  { staticClass: "status" },
                  [
                    item.factoryConfirmedStatus == 0
                      ? [_vm._v("待确认")]
                      : _vm._e()
                  ],
                  2
                ),
                _c("Icon", {
                  staticClass: "item-arrow",
                  attrs: { name: "arrow" }
                })
              ],
              1
            )
          ]
        )
      }),
      !_vm.isShowAll
        ? _c(
            "Button",
            { attrs: { type: "default" }, on: { click: _vm.loadMore } },
            [_vm._v("点击加载更多")]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }